import AuthContext from './AuthContext';
import { JWTContextType } from './auth';
import { useContext } from 'react';

const useAuth = () => useContext(AuthContext) as JWTContextType;

export default useAuth;
